import { API_ENDPOINTS } from "config/apiConfig";
import {
  TransactionHistoryFilter,
  Delete,
  TransactionFilter,
  TransactionListPaginate,
  Filter,
} from "common/interfaces";
import { PAGINATION } from "common/enums/Pagination.enum";
import { baseApi } from "./baseApi";

export const transactionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get Transaction
    getTransactions: builder.query<
      TransactionListPaginate,
      { filter?: TransactionFilter; page?: number }
    >({
      query: ({ filter, page }) => ({
        url: API_ENDPOINTS.TRANSACTION_LIST,
        params: {
          page: page || PAGINATION.PAGE,
          limit: PAGINATION.LIMIT,
          ...filter,
        },
      }),
      providesTags: ["Transaction"],
    }),

    // Get Transaction History
    getTransactionHistories: builder.query<
      TransactionListPaginate,
      { filter?: TransactionHistoryFilter; page?: number }
    >({
      query: ({ filter, page }) => ({
        url: API_ENDPOINTS.TRANSACTION_HISTORY,
        params: {
          page: page || PAGINATION.PAGE,
          limit: PAGINATION.LIMIT,
          ...filter,
        },
      }),
      providesTags: ["Transaction"],
    }),

    // Delete Transaction
    deleteTransaction: builder.mutation<Delete, React.Key[]>({
      query: (codes) => ({
        url: API_ENDPOINTS.DELETE_TRANSACTION,
        method: "DELETE",
        body: { codes },
      }),
      invalidatesTags: ["Transaction"],
    }),

    // Download CSV
    downloadTransactionCsv: builder.mutation<
      Blob,
      { filter: Filter; fileName: string }
    >({
      query: ({ filter, fileName }) => ({
        url: API_ENDPOINTS.TRANSACTION_CSV,
        method: "GET",
        params: filter,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          return blob;
        },
      }),
    }),
  }),
});

export const {
  useGetTransactionsQuery,
  useGetTransactionHistoriesQuery,
  useDeleteTransactionMutation,
  useDownloadTransactionCsvMutation,
} = transactionApi;
